import { defineStore } from 'pinia';
import {
  PUBLISHING_SCOPE,
  PublishingScope,
} from 'commons/publishing/publishingScope.ts';

type State = {
  currentScope?: PublishingScope;
};

export const usePublishingStore = defineStore('publishing', {
  state: (): State => ({
    currentScope: undefined,
  }),

  getters: {
    isMpScope(state): boolean {
      return state.currentScope?.key === PUBLISHING_SCOPE.MP.key;
    },
    isShopScope(state): boolean {
      return state.currentScope?.key === PUBLISHING_SCOPE.SHOP.key;
    },
    hasScope(): boolean {
      return this.isMpScope || this.isShopScope;
    },
  },

  actions: {
    setCurrentScope(scope?: PublishingScope) {
      this.currentScope = scope;
    },
  },
});
